export const langs = [
    {
        lang: 'en',
        translation: {
            '': '',
            add_on_existing: 'Add on existing',
            add_new_only: 'Add New Only',
            CLI: 'CLI',
            NCLI: 'NCLI',
            CC: 'Call Center',
            'Call Center': 'Call Center',
            add_dialplan: 'Add Dialplan',
            upload_rate: 'Upload Rate',
            prefix_start: 'Prefix Start',
            show_rates: 'Show Rates',
            rates_counter: 'Rates Counter',
            add: 'Add',
            testing_numbers_document: 'Testing Numbers Document',
            ip: 'IP',
            ssh_port: 'SSH Port',
            host: 'Host',
            dialplan_document: 'Dialplan Document',
            ssh_password: 'SSH Password',
            cli_number: 'CLI Number',
            number: 'Number',
            clean_previous_dialplan: 'Clean Previous Dialplan',
            dial_code: 'Dial Code',
            clean_previous_rates: 'Clean Previous Rates',
            upload_options: 'Upload Options',
            rates_document: 'Rates Document',
            division: 'Division',
            trunk_ip: "Trunk IP",
            name: 'Name',
            label: 'Label',
            music: 'Music is Love',
            phone_numbers: 'phone numbers',
            test_type: 'test type',
            make_test: 'make test',
            're-test': 'Re-Test',
            home_page: 'Home Page',
            location: 'Location',
            nickname: 'Nickname',
            user_link_for_vos_login: 'User Link For VOS Login',
            codec: 'Codec',
            fusion_server: 'Fusion Server',
            jikatel_vos_ip: 'Jikatel VOS IP',
            rate: 'Rate',
            vendor: 'Vendor',
            jikatel_user: 'User',
            destination: 'Destination',
            search: 'Search',
            extension: 'Extension',
            dial_plan: 'DialPlan',
            rates: 'Rates',
            testing_numbers: 'Testing Numbers',
            cli_destination: 'CLI Destination',

            title: 'title',
            brief: 'brief',
            description: 'description',
            category: 'category',
            note: 'note',
            alert_message: 'alert message',
            username: 'Username',
            tags: 'tags',
            field_name: 'field name',
            required: 'required',
            type: 'type',
            failed: 'failed',
            password_changed: 'password changed',
            old_password: 'old password',
            new_password: 'new password',
            email: 'email',
            display_name: 'display name',
            deleted: 'deleted',
            remove: 'remove',
            cancel: 'cancel',
            updated: 'update',
            edit: 'Edit',
            name_of_the_user: 'name of the user',
            details: 'details',
            actions: 'actions',
            list: "list",
            user: 'user',
            successfully: 'successfully',
            create: 'create',
            created: 'created',
            password: 'password',
            profile: 'profile',
            logout: 'logout',
            this_field_is_required: 'this field is required',
            fields_do_not_match_the_required_criteria: 'fields do not match the required criteria'
        }
    }
]

export default langs
